import React from "react";
import { useSelector } from "react-redux";
import { useState, useEffect } from "react";
import useSnackbar from "../../../hooks/useSnackbar";
import { makeStyles } from "@mui/styles";
import {
  salesOrderActiveWorkflowsTable,
  salesOrderRelationshipsTable,
  salesOrderSystemNotesTable,
  salesOrderWorkflowHistoryTable,
} from "../../../config/grid-column-defs";
import AgGridPaginatedTable from "../../../components/AgGridPaginatedTable";

import { slugMap } from "../../../config/slug-config";
import { useParams } from "react-router-dom";
import {
  Box,
  Grid,
  InputLabel,
  MenuItem,
  FormControl,
  Select,
  Tabs,
  Tab,
  CircularProgress,
  Button,
} from "@mui/material";
import TabPanel from "../../../components/TabPanel";
import { getTransactionRelationshipcontact } from "../../../api/journal";
import { getTransactionNotAvailable } from "../../../config/grid-value-formatters";
import { getTransactionCommonSytemNotes } from "../../../api/transaction-type";

const useStyles = makeStyles((theme) => ({
  spacedTabs: {
    "& .MuiTab-root": {
      marginRight: theme.spacing(2), // Adjust the spacing as needed
    },
  },
}));
export default function SystemInformationHeader() {
  const classes = useStyles();
  const snackbar = useSnackbar();
  const { data: user } = useSelector((state) => state.user);
  const params = useParams();
  const [loading, setLoading] = useState(false);
  const [tabIndex, setTabIndex] = useState(0);
  const pageDetail = slugMap[params.slug];
 const [tabIndexRelatedRecord, setTabIndexRelatedRecord] = useState(0);
  const [rowData, setRowData] = useState([]);

  // const [tableRefreshCount, setTableRefreshCount] = useState(0);
  // function refreshTable () {
  //     setTableRefreshCount(prev => prev + 1);
  // }

  // async function getTransactionRelationshipcontactData(limit, offset) {
  //   try {
  //     const { data } = await getTransactionRelationshipcontact(user.token, {
  //       id: params.docNo,
  //       limit,
  //       offset,
  //     });
  //     return {
  //       rows: data.data.data,
  //       total: data.data.total,
  //       error: false,
  //     };
  //   } catch (error) {
  //     console.log(error);
  //     snackbar.showError("Error In Loading Data.");
  //     return { error: true };
  //   }
  // }
  async function getTransactionCommonSytemNotesData(limit, offset) {
    setLoading(true);
    try {
      const { data } = await getTransactionCommonSytemNotes(user.token, {
        id: params.docNo,
        limit,
        offset,
      });
      setRowData(data.data.data);
      setLoading(false);
      return { rows: data.data.data, total: data.data.total, error: false };
    } catch (error) {
      console.log(error);
      setLoading(false);
      snackbar.showError("Error In Loading Data.");
      return { error: true };
    } finally {
      setLoading(false);
    }
  }
  const buttonStyle = {
    margin: "5px", // Adjust the spacing as needed
  };
  return (
    <>
      <Box
             sx={{
               maxWidth: { xs: "100%", sm: "100%", md: "100%" },
               bgcolor: "#fff",
               p: 1,
             }}
           >
        <Tabs
          value={tabIndexRelatedRecord}
          // onChange={handleChange}
          onChange={(e, nv) => {
            setTabIndexRelatedRecord(nv);
          }}
          variant="scrollable"
          scrollButtons="auto"
          aria-label="scrollable auto tabs example"
          className={`${classes.spacedTabs} tabs-sub-bkg`}
          // className="tabs-sub-bkg"
        >
          <Tab label="System Notes" />
          <Tab label="Active Workflows" />
          <Tab label="Workflow History" />
        </Tabs>

        {/*Contacts*/}
        <TabPanel value={tabIndex} index={0}>
          <Box className="viewDetilsBox">
            <Grid container spacing={2}>
              <Grid item xs={12} sm={4} md={4} className="m-b-10">
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">VIEW</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value=""
                    label="CONTACT"
                    MenuProps={{
                      className:"ve-dropdown",
                    }}
                  >
                    <MenuItem value="list">List</MenuItem>
                    <MenuItem value="search">Search</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={4} md={3} className="m-b-10">
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">FIELD<span style={{color:"red"}}>*</span></InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value=""
                    label="ROLE"
                    MenuProps={{
                      className:"ve-dropdown",
                    }}
                  >
                    <MenuItem value="alternatecontact">
                      Alternate Contact
                    </MenuItem>
                    <MenuItem value="consultant">Consultant</MenuItem>
                    <MenuItem value="decisionmaker">Decision Maker</MenuItem>
                    <MenuItem value="ordercreator">Order Creator</MenuItem>
                    <MenuItem value="primarycontact">Primary Contact</MenuItem>
                    <MenuItem value="licensenotification">
                      License Notification
                    </MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </Box>
          <Box className="viewDetailsBox" display="flex">
            <Button className="backBtn" style={buttonStyle} onClick={() => {}}>
              CUSTOMIZED VIEW
            </Button>
          </Box>
          <AgGridPaginatedTable
            getTableRows={getTransactionCommonSytemNotesData}
            columns={salesOrderSystemNotesTable}
            refreshCounter={0}
            perPage={5}
          />
        </TabPanel>
        <TabPanel value={tabIndex} index={1}>
          <Box className="viewDetilsBox">
            <Grid container spacing={2}>
              <Grid item xs={12} sm={4} md={4} className="m-b-10">
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">
                    ATTACH EXISTING FILE
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value=""
                    label="ATTACH EXISTING FILE"
                    MenuProps={{
                      className:"ve-dropdown",
                    }}
                  >
                    <MenuItem value="list">List</MenuItem>
                    <MenuItem value="search">Search</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </Box>
          <Box className="viewDetailsBox" display="flex">
            <Button className="backBtn" style={buttonStyle} onClick={() => {}}>
              Attach
            </Button>
            <Button className="backBtn" style={buttonStyle} onClick={() => {}}>
              New File
            </Button>
          </Box>
          <AgGridPaginatedTable
            // getTableRows={getTransactionNotAvailable}
            columns={[]}
            // columns={salesOrderActiveWorkflowsTable}
            perPage={5}
            refreshCounter={0}
          />
        </TabPanel>
        <TabPanel value={tabIndex} index={2}>
          <Box className="viewDetilsBox">
            <Grid container spacing={2}>
              <Grid item xs={12} sm={4} md={4} className="m-b-10">
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">VIEW</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value=""
                    label="VIEW"
                    MenuProps={{
                      className:"ve-dropdown",
                    }}
                  >
                    <MenuItem value="list">List</MenuItem>
                    <MenuItem value="search">Search</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </Box>
          <Box className="viewDetailsBox" display="flex">
            <Button className="backBtn" style={buttonStyle} onClick={() => {}}>
              NEW NOTE
            </Button>
            <Button className="backBtn" style={buttonStyle} onClick={() => {}}>
              VIEW HISTORY
            </Button>
            <Button className="backBtn" style={buttonStyle} onClick={() => {}}>
              CUSTOMIZE VIEW
            </Button>
          </Box>
          <AgGridPaginatedTable
            // getTableRows={getTransactionNotAvailable}
            columns={[]}
            // columns={salesOrderWorkflowHistoryTable}
            perPage={5}
            refreshCounter={0}
          />
        </TabPanel>
      </Box>
    </>
  );
}
